var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('post-item',{attrs:{"post":_vm.post,"auth-user":_vm.authUser,"reactions":_vm.reactions,"show-league":"","list-type":''}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }